<script lang="ts">
	import keyUrl from '@papyria/brand/generated/key-light.svg?url';
	import wordmarkUrl from '@papyria/brand/svg/wordmark.svg?url';

	let { href }: { href: string } = $props();
</script>

<a {href} class="group flex shrink-0 items-center gap-2">
	<img src={keyUrl} alt="" class="size-6" />
	<span
		aria-hidden="true"
		class="block aspect-[3920/879] h-4 bg-ink mask-contain mask-center mask-no-repeat transition-colors group-hover:bg-muted motion-reduce:transition-none"
		style:mask-image="url({wordmarkUrl})"
	></span>
	<span class="sr-only">papyria</span>
</a>
